export default __webpack_public_path__ + "static/pala-2-f146bca82595562ef0bfb99c15fe68af.jpg";